import { observable, action, reaction, decorate } from 'mobx';

class CommonStore {
  token = window.localStorage.getItem('jwt');
  activePage = undefined;

  constructor() {
    reaction(
      () => this.token,
      token => {
        if (token) {
          window.localStorage.setItem('jwt', token);
          /** force new not supported browser notification */
          window.localStorage.removeItem('NOT_SUPPORTED_BROWSER_MESSAGE');
          window.localStorage.removeItem(
            'NOT_SUPPORTED_BROWSER_MESSAGE_LIBRARY'
          );
        } else {
          window.localStorage.removeItem('jwt');
        }
      }
    );
  }

  setActivePage(page) {
    this.activePage = page;
  }

  setToken(token) {
    this.token = token;
  }
}

const MobxCommonStore = decorate(CommonStore, {
  token: observable,
  activePage: observable,
  setToken: action,
  setActivePage: action
});

export default new MobxCommonStore();
